import { DateMask } from "Components/Form/InputMasks/DateMask";
import { FieldMessage } from "Components/Form/Fields";

export const DateField = ({
  onChange,
  field,
  value,
  error = {},
  ageGate,
  ...props
}) => {
  const handleText = (value) => {
    onChange({ [field.name]: value });
  };

  return (
    <>
      <DateMask
        date={value}
        onChange={(value) => handleText(value)}
        error={!!error.status}
        placeholder={field.placeholder ?? "Date of Birth (MM/DD/YYYY)"}
        ageGate={ageGate}
        {...props}
      />
      <FieldMessage active={!!error.status} content={error.message} />
    </>
  );
};
